module.exports = __webpack_public_path__ + "img/yo-screen-1.39fc0ff2.webp";